// Module
var code = "<react-component name=\"EditAppointmentType\"></react-component>\n";
// Exports
module.exports = code;